import styled from 'styled-components';
import H6 from 'UIComponents/elements/headings/H6';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getLanguageNameFromCode } from '../../utils/langUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIAlert = styled(UIAlert).withConfig({
  displayName: "TemplateEditorSidebarAlert__StyledUIAlert",
  componentId: "sc-175o76h-0"
})(["padding-top:20px !important;padding-bottom:20px !important;margin:0 20px 12px !important;"]);
const StyledContentWrapper = styled.div.withConfig({
  displayName: "TemplateEditorSidebarAlert__StyledContentWrapper",
  componentId: "sc-175o76h-1"
})(["margin-top:20px;margin-bottom:4px;"]);
const StyledUIButton = styled(UIButton).withConfig({
  displayName: "TemplateEditorSidebarAlert__StyledUIButton",
  componentId: "sc-175o76h-2"
})(["margin-top:8px;padding:7px 2.5rem !important;"]);
export default function TemplateEditorSidebarAlert({
  masterLanguage,
  selectedLanguage,
  handleTranslateClick
}) {
  return /*#__PURE__*/_jsxs(StyledUIAlert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.templateEditor.sidebar.alert.title",
      options: {
        primaryLanguage: getLanguageNameFromCode(masterLanguage)
      }
    }),
    type: "warning",
    children: [/*#__PURE__*/_jsxs(StyledContentWrapper, {
      children: [/*#__PURE__*/_jsx(H6, {
        className: "m-bottom-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.templateEditor.sidebar.alert.contentHeader"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.templateEditor.sidebar.alert.content",
          options: {
            selectedLanguage: getLanguageNameFromCode(selectedLanguage)
          }
        })
      })]
    }), /*#__PURE__*/_jsx(StyledUIButton, {
      use: "tertiary",
      size: "small",
      onClick: handleTranslateClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.sidebar.translation.editButton"
      })
    })]
  });
}